import { DataGridBody, DataGridCell, DataGridRow } from '@twilio-paste/core/data-grid';

import { AppModel, TargetStatus } from '../../../modules/Apps';

import { TargetsTableActions } from './TargetsTableActions';
import { TargetsTableStatus } from './TargetsTableStatus';

interface TargetsTableBodyProps {
  app: AppModel;
}

export function TargetsTableBody({ app }: TargetsTableBodyProps) {
  const { targets = [] } = app;

  return (
    <DataGridBody>
      {targets?.map(target => (
        <DataGridRow key={target.targetId}>
          <DataGridCell>{target.name}</DataGridCell>
          <DataGridCell>{target.targetId}</DataGridCell>
          <DataGridCell>{app.name}</DataGridCell>
          <DataGridCell>
            <TargetsTableStatus enabled={target.status === TargetStatus.Enabled} />
          </DataGridCell>
          <DataGridCell textAlign="center">
            <TargetsTableActions target={target} />
          </DataGridCell>
        </DataGridRow>
      ))}
    </DataGridBody>
  );
}
